import { useMemo } from "react";
import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { getPortfolioAssignmentClassificationById, portfolioPlanAssignmentClassificationByIdURL, PortfolioPlanClassification, } from "../request/getPortfolioPlanAssignmentClassificationById";
import { FinMasonError } from "../types";
import { portfolioPlanByIdKeyMaker } from "./useGetPortfolioPlanById";
import { assignmentKeyMaker } from "./usePortfolioPlanAssignment";
import { assignmentsKeyMaker } from "./usePortfolioPlanAssignments";
export { FinMasonError, PortfolioPlanClassification };
function keyMaker(portfolioPlanId, portfolioAssignmentId) {
    return [
        // This allows a reset if the assignment changes
        ...assignmentsKeyMaker({ abstractPortfolioId: portfolioPlanId }),
        ...assignmentKeyMaker({
            abstractPortfolioId: portfolioPlanId,
            portfolioPlanAssignmentId: portfolioAssignmentId,
        }),
        ...portfolioPlanByIdKeyMaker(portfolioPlanId, {}), // This allows a reset if the portfolio plan changes
        portfolioPlanAssignmentClassificationByIdURL(portfolioPlanId, portfolioAssignmentId),
    ];
}
const useGetPortfolioPlanClassificationByIdFactoryHook = makeDoubleArgHook(getPortfolioAssignmentClassificationById, keyMaker);
function useGetPortfolioPlanClassificationById(portfolioPlanId, portfolioAssignmentId, config) {
    const result = useGetPortfolioPlanClassificationByIdFactoryHook(portfolioPlanId, portfolioAssignmentId, config);
    return useMemo(() => {
        if (result.isLoading || result.hasError) {
            return result;
        }
        // turn this into an error
        if (result.data instanceof FinMasonError) {
            return {
                hasError: true,
                error: result.data,
                isLoading: false,
                data: undefined,
            };
        }
        // typescript type checking requires that we create a new object
        return { data: result.data, isLoading: false, hasError: false };
    }, [result]);
}
export default useGetPortfolioPlanClassificationById;
//# sourceMappingURL=useGetPortfolioAssignmentClassificationById.js.map